<div class="dialog-content">
  <rt-dialog-header
    [heading]="'app.email_provider_microsoft.title' | translate"
    [class.has-dialog-info]="errorMessage !== EmailProvidersErrors.onPremise"
    icon="microsoft-logo"
    iconSize="medium"
  />

  @if (errorMessage !== EmailProvidersErrors.onPremise) {
    <rt-dialog-body
      [class.has-dialog-info]="errorMessage !== EmailProvidersErrors.onPremise"
      variant="white"
      layout-vertical
    >
      @if (microsoftConnected) {
        <rt-message variant="context-information">
          {{ 'app.email_provider_microsoft.mailbox_connected' | translate }}
        </rt-message>
      }

      @if (!microsoftConnected) {
        <rt-message variant="context-warning">
          <strong>{{ 'app.email_provider_mailbox.notice' | translate }}</strong>
          <br />
          {{ 'app.email_provider_mailbox.sync_info' | translate }}
          <a
            href="{{ 'app.support_resources.mailbox_sync' | translate }}"
            target="_blank"
            class="infobox-link"
          >
            {{ 'app.email_provider_mailbox.read_more_here' | translate }}
          </a>
        </rt-message>
        <rt-divider variant="default" />
        <p>{{ 'app.email_provider_microsoft.info' | translate }}</p>

        <rt-divider variant="default" />
        @if (errorMessage && errorProvider === EmailProviders.Microsoft) {
          <rt-infobox [isDismissible]="false" [type]="'error'" [iconName]="'error'">
            {{ errorMessage }}
          </rt-infobox>
        }

        <rt-divider variant="default" />
        <rt-group layout>
          <a rt-button variant="primary" margin-right-small (click)="connectClick()">
            <rt-icon name="swap-horiz" />
            @if (errorMessage) {
              <span>{{ 'app.email_provider_common.connect_again' | translate }}</span>
            }
            @if (!errorMessage) {
              <span>{{ 'app.email_provider_common.connect' | translate }}</span>
            }
          </a>
          <rt-button variant="plain" (click)="cancelClick()">
            {{ 'app.common.cancel' | translate }}
          </rt-button>
        </rt-group>
      }
    </rt-dialog-body>
  }

  @if (errorMessage === EmailProvidersErrors.onPremise) {
    <rt-dialog-body layout-vertical>
      <rt-infobox
        [heading]="
          'app.email_provider_microsoft.on_premise_step.warning_infobox.heading' | translate
        "
        [isDismissible]="false"
        iconName="warning"
        type="warning"
        padding-bottom
      >
        {{
          'app.email_provider_microsoft.on_premise_step.warning_infobox.subheading' | translate
        }}</rt-infobox
      >
      <span text-darkest padding-bottom>{{
        'app.email_provider_microsoft.on_premise_step.select_option' | translate
      }}</span>
      <a [href]="connectUrl">
        <rt-box
          [hasHoverState]="true"
          variant="padding-small"
          class="on-premise-option"
          margin-bottom
        >
          <div layout-vertical layout-flex-1-1>
            <div layout layout-align-items-center="">
              <rt-heading margin-right-small>{{
                'app.email_provider_microsoft.on_premise_step.option_1.heading' | translate
              }}</rt-heading>
            </div>
            <rt-heading variant="subheading normal">{{
              'app.email_provider_microsoft.on_premise_step.option_1.subheading' | translate
            }}</rt-heading>
          </div>
          <rt-icon [name]="'chevron-right'" [size]="'medium'" class="arrow-icon" />
        </rt-box>
      </a>

      <rt-box
        [hasHoverState]="true"
        (click)="onPremiseSelected()"
        variant="padding-small"
        class="on-premise-option"
        margin-bottom
      >
        <div layout-vertical layout-flex-1-1>
          <div layout layout-align-items-center>
            <rt-heading margin-right-small>{{
              'app.email_provider_microsoft.on_premise_step.option_2.heading' | translate
            }}</rt-heading>
          </div>
          <rt-heading variant="subheading normal">{{
            'app.email_provider_microsoft.on_premise_step.option_2.subheading' | translate
          }}</rt-heading>
        </div>
        <rt-icon [name]="'chevron-right'" [size]="'medium'" class="arrow-icon" />
      </rt-box>

      <rt-box
        [hasHoverState]="true"
        (click)="cancelClick()"
        variant="padding-small"
        class="on-premise-option"
      >
        <div layout-vertical layout-flex-1-1>
          <div layout layout-align-items-center>
            <rt-heading margin-right-small>{{
              'app.email_provider_microsoft.on_premise_step.option_3.heading' | translate
            }}</rt-heading>
          </div>
          <rt-heading variant="subheading normal">{{
            'app.email_provider_microsoft.on_premise_step.option_3.subheading' | translate
          }}</rt-heading>
        </div>
        <rt-icon [name]="'chevron-right'" [size]="'medium'" class="arrow-icon" />
      </rt-box>
    </rt-dialog-body>
  }
</div>

@if (errorMessage !== EmailProvidersErrors.onPremise) {
  <div class="dialog-info-box">
    <rt-heading variant="heading large light">
      <rt-icon name="info" colorToken="colorIconInfoDefault" />
      {{ 'app.email_provider_security_info.title' | translate }}
    </rt-heading>
    <p margin-top-small [innerHTML]="'app.email_provider_security_info.info' | translate"></p>

    <dl margin-tb>
      <dt>
        {{ 'app.email_provider_security_info.li_1.title' | translate }}
      </dt>
      <dd>
        {{ 'app.email_provider_security_info.li_1.description' | translate }}
      </dd>
    </dl>
    <!--    TODO: Uncomment when we start encrypting passwords to mailboxes-->
    <!--    <div layout-horizontal>-->
    <!--      <rt-icon margin-top-small margin-right-small name="check"></rt-icon>-->
    <!--      <div layout-vertical>-->
    <!--        <h5 margin-top-small text-bold text-darkest>-->
    <!--          {{ 'app.email_provider_security_info.li_2.title' | translate }}-->
    <!--        </h5>-->
    <!--        <p>{{ 'app.email_provider_security_info.li_2.description' | translate }}</p>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
}
